<div
  [ngClass]="{
    'bg-red-50 border-red-200': isMissing,
    'bg-blue-50 border-blue-200': !isMissing,
  }"
  class="rounded-lg p-6 shadow-sm border"
>
  <div class="flex mb-4">
    <div class="flex flex-col" *ngIf="question.index_number">
      <div
        class="font-bold rounded-full w-8 h-8 flex items-center justify-center mr-3"
        [ngClass]="{
          'bg-red-100 border-red-200': isMissing,
          'bg-blue-100 text-blue-700': !isMissing,
        }"
      >
        {{ question.index_number }}
      </div>
    </div>
    <h2 class="text-lg font-semibold">
      <span [innerHTML]="questionHtml | safeHtml"></span>
    </h2>
  </div>
  <div class="mt-4" [ngClass]="{ 'sm:px-10': question.index_number }">
    <textarea
      [name]="'question_' + question.uuid"
      (input)="handleInput($event)"
      [attr.maxlength]="maxLength"
      rows="5"
      class="w-full p-3 border border-gray-300 rounded-md resize-y focus:outline-none focus:ring-2 focus:ring-blue-500"
      [placeholder]="inputHint"
    ></textarea>
    <p class="text-sm mt-2 text-right" [ngClass]="isNearLimit ? 'text-amber-600' : 'text-gray-500'">
      {{ charCount }}/{{ maxLength }} characters
    </p>
  </div>
</div>
